// extracted by mini-css-extract-plugin
module.exports = {"Row":"Cart_Row__vmxiH","Cross":"Cart_Cross__2C2v0","ItemRight":"Cart_ItemRight__3CLdy","Desc":"Cart_Desc__1D4Mj","Counter":"Cart_Counter__29gfy"};